import React, { useEffect } from 'react';
import Template from './Template/Template';
import exclamation from 'src/assets/images/error-icon.svg';

import './BankFailure.scss';

import { STEP_MANUAL } from '../AddBank/AddBank';

export const TimeOutFailure = ({
  dispatchPageLoad,
  handleClose,
  setBankProgress,
}) => {
  useEffect(() => {
    dispatchPageLoad('TimeOutBankError');
  }, [dispatchPageLoad]);

  return (
    <div>
      <Template
        image={exclamation}
        header={`Your session has expired.`}
        msg={`Your session has expired due to inactivity. Please try again and enter your bank account details.`}
        nextButton={`Try Again`}
        onNextClick={() => setBankProgress(STEP_MANUAL)}
        backButton={`Cancel`}
        onBackClick={() => handleClose()}
      />
    </div>
  );
};

export default TimeOutFailure;
